import React from 'react';

import {Helmet, translate} from 'views/module';
import SceneClientForm from 'views/scenes/form/ClientForm';

const App = () => {
  return (
    <>
      <Helmet>
        <title>{translate('form.Helmet.title')}</title>
      </Helmet>
      <SceneClientForm />
    </>
  );
};

export default App;
